ggTimelineLoaded.$inject = ["$timeout"];angular.
module('gplans.directives').
directive('ggTimelineLoaded', ggTimelineLoaded);

ggTimelineLoaded.$inject = ['$timeout'];

function ggTimelineLoaded($timeout) {
  return {
    restrict: 'E',
    link: function link($scope, element, attrs) {
      console.log(element, attrs);
      $scope.$on('dataloaded', function () {
        // You might need this timeout to be sure its run after DOM render.
        $timeout(function () {
          var $timeline_block = $('.cd-timeline-block');

          //hide timeline blocks which are outside the viewport
          $timeline_block.each(function () {
            if ($(this).offset().top > $(window).scrollTop() + $(window).height()) {
              $(this).find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
            }
          });

          //on scolling, show/animate timeline blocks when enter the viewport
          $(window).on('scroll', function () {
            $timeline_block.each(function () {
              if ($(this).offset().top <= $(window).scrollTop() + $(window).height() * 0.75 && $(this).find('.cd-timeline-img').hasClass('is-hidden')) {
                $(this).find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
              }
            });
          });
        }, 0, false);
      });
    } };

}